<!--
  ~ Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="head">
    Multi-invulling: {{ record?.project?.naam }}
</div>
<div class="content">
    <form #form='ngForm' autocomplete="off">
        <tabset>
            <tab heading="Diensten">
            @if (selectieDiensten.length === 0) {
                <p>Er zijn geen diensten om te selecteren.</p>
            }
                @else {
                    <p><em>Selecteer de in te vullen diensten handmatig of met een snelle knop.
                    @if(this.alIngevuld) {
                       De <span class="text-danger">gekleurde</span> diensten hebben zelf al een invulling. Dit wordt overschreven door de nieuwe invulling.
                    }
                    </em></p>
                    <div class="dienstselect">
                        <button class="btn btn-sm btn-primary" (click)="selectie('alles')">Alles</button>
                        <button class="btn btn-sm btn-primary" (click)="selectie('niets')">Niets</button>
                        <button class="btn btn-sm btn-primary" (click)="selectie('1 week')">1 week</button>
                        <button class="btn btn-sm btn-primary" (click)="selectie('6 weken')">6 weken</button>
                        <button class="btn btn-sm btn-primary" (click)="selectie('jaar')">Jaar</button>
                    </div>
                    <div class="form-row">
                        @for (dienst of selectieDiensten; track dienst.id) {
                            <div class="w-col-6 w-col-md-4 w-col-xl-3 mb-1">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" name="dienst_{{dienst.id}}"
                                           [id]="id('dienst_' + dienst.id)"
                                           [(ngModel)]="dienst._tags.selecteer">
                                    <label class="form-check-label no-select" [class.text-danger]="dienst.heeftInvulling" [class.font-weight-bold]="isOrigineel(dienst)" [for]="id('dienst_' + dienst.id)">{{dienst.nlStartdag}} {{dienst.nlStartdate}} {{dienst.starttime}} - {{dienst.endtime}}</label>
                                </div>
                            </div>
                        }
                    </div>
                }
            </tab>
            <tab heading="Invulling ({{geselecteerdeDiensten.length}})" [customClass]="geselecteerdeDiensten.length ? '' : 'd-none'">
                <div class="text-danger mb-2">Let op: hiermee vervang je de invulling van alle geselecteerde diensten. We controleren hier niet op overlap / vrije dagen. Controleer dus zelf goed de gewijzigde diensten.</div>
                @if(wisselendeCapaciteit) {
                    <div class="text-danger mb-2 font-weight-bold">De geselecteerde diensten hebben een wisselende capaciteit. We vullen elke dienst tot maximaal de opgegeven capaciteit, met de mensen die je hier van boven naar beneden kiest.</div>
                }
                @if(! record?.heeftInvulling) {
                    <div class="text-danger mb-2">Doorvoeren zonder invulling: bij alle geselecteerde diensten halen we de invulling weg.</div>
                }
                <planitem-invulling
                        [record]="record"
                        [volLezen]="true"
                        [magPersoneelEdit]="true"
                        [lookups]="lookups"
                        [lookupHashes]="lookupHashes"
                        [negeerFilter]="negeerFilter"
                        [allitemsPerdate]="allitemsPerdate"
                        [dropdownContainer]="dropdownContainer"
                        [filtertool]="filtertool">
                </planitem-invulling>
            </tab>
        </tabset>
    </form>
</div>
<div class="foot">
    <div class="buttons" links>
        <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
    </div>
    <div class="buttons" rechts>
        @if (ietsWeggefilterd) {
            <div class="mr-2">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [id]="id('negeerFilter')"
                           name="negeerFilter"
                           [(ngModel)]="negeerFilter" [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="negeerFilterChanged()">
                    <label class="custom-control-label text-light" [for]="id('negeerFilter')"
                           title="Schakel toepassen van planbordfilter voor keuzes in dit scherm aan of uit">Negeer
                        planbordfilter</label>
                </div>
            </div>
        }
        <button class="btn btn-primary" (click)="uitvoeren()" [disabled]="! geselecteerdeDiensten?.length">Opslaan op alle geselecteerde diensten</button>
    </div>
</div>
